<template>
	<!-- v-html="params.headerName" -->
	<div v-html="headerHrml" :title="params.keywordObj.keyword"></div>
	<!-- v-html renders the HTML -->
</template>
  
  <script>
export default {
	props: {
		onePs: Object, // Pass the data object that contains the `id` and `url`
	},
	data() {
		return {
			headerHrml: "",
		};
	},
	created() {
		this.getHeaders();
	},
	methods: {
		// This method will be called when the user clicks on the link
		getHeaders() {
			this.headerHrml = `<span>
  ${
		// Split the keyword by spaces
		this.params.keywordObj.keyword.split(" ").length > 1
			? this.params.keywordObj.keyword.split(" ")[0] +
			  "<br>" +
			  this.params.keywordObj.keyword.split(" ").slice(1).join(" ")
			: this.params.keywordObj.keyword
	}
</span> <br> 
          <i><span style="color: grey;">
  CPC: ${Number(this.params.keywordObj.cpc).toLocaleString("fr-FR", {
		style: "currency",
		currency: "EUR",
	})}
</span>
<br>
<span style="color: grey;">
  Volume: ${Number(this.params.keywordObj.search_volume).toLocaleString("fr")}
</span>
</i>
`;
		},
	},
};
</script>
  